import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { MailingProvider } from './contexts/MailingContext';
import { LocaleProvider } from './contexts/LocaleContext';
import { ToastProvider } from './contexts/ToastContext';
import ToastContainer from './components/ToastContainer';
import ProtectedRoute from './components/ProtectedRoute';

// Pages
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';

import LoadsPage from './pages/LoadsPage';
import RequestedLoadsPage from './pages/RequestedLoadsPage';
import ClientsPage from './pages/ClientsPage';
import TransporteursPage from './pages/TransporteursPage';
import DriversPage from './pages/DriversPage';
import DriverDetailPage from './pages/DriverDetailPage';
import TrucksPage from './pages/TrucksPage';
import TruckDetailPage from './pages/TruckDetailPage';
import ProductsPage from './pages/ProductsPage';
import PortsPage from './pages/PortsPage';
import MolesPage from './pages/MolesPage';
import WeighbridgesPage from './pages/WeighbridgesPage';
import UsersPage from './pages/UsersPage';
import TicketsPage from './pages/TicketsPage';
import CertificatesPage from './pages/CertificatesPage';
import BillsPage from './pages/BillsPage';
import PaymentsPage from './pages/PaymentsPage';
import ReportsPage from './pages/ReportsPage';
import TruckTrackingPage from './pages/TruckTrackingPage';
import SuperDashboardPage from './pages/SuperDashboardPage';
import GPSPage from './pages/GPSPage';
import DriverMyTrucksPage from './pages/DriverMyTrucksPage';
import ErrorLogsPage from './pages/ErrorLogsPage';
import SystemConfigPage from './pages/SystemConfigPage';
import AdminStatsPage from './pages/AdminStatsPage';
import DDPCreateGate from './components/DDPCreateGate';
import DDPDetailPage from './pages/DDPDetailPage';
import OperatorRegisterPage from './pages/OperatorRegisterPage';
import OperatorRegisterPendingPage from './pages/OperatorRegisterPendingPage';
import ChefZoneDDPDashboard from './pages/ChefZoneDDPDashboard';
import DDPListPage from './pages/DDPListPage';

function App() {
  return (
    <AuthProvider>
      <LocaleProvider>
      <MailingProvider>
      <ToastProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              {/* Public routes */}
              <Route path="/login" element={<LoginPage />} />
              
              {/* Protected routes */}
              <Route path="/" element={
                <ProtectedRoute>
                  <Navigate to="/dashboard" replace />
                </ProtectedRoute>
              } />
              
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <DashboardPage />
                </ProtectedRoute>
              } />
              
              <Route path="/super-dashboard" element={
                <ProtectedRoute requiredRoles={['SUPER']}>
                  <SuperDashboardPage />
                </ProtectedRoute>
              } />
              
              
              <Route path="/loads" element={
                <ProtectedRoute requiredRoles={['MANAGER', 'CLIENT', 'PESEUR', 'DRIVER', 'ACCOUNTANT', 'SUPER']}>
                  <LoadsPage />
                </ProtectedRoute>
              } />

              <Route path="/gps" element={
                <ProtectedRoute requiredRoles={['DRIVER']}>
                  <GPSPage />
                </ProtectedRoute>
              } />

              <Route path="/driver/trucks" element={
                <ProtectedRoute requiredRoles={['DRIVER']}>
                  <DriverMyTrucksPage />
                </ProtectedRoute>
              } />

              <Route path="/requestedloads" element={
                <ProtectedRoute requiredRoles={['MANAGER', 'CLIENT', 'PESEUR']}>
                  <RequestedLoadsPage />
                </ProtectedRoute>
              } />

                              {/* DDP/OOP/Client/Chef de zone routes */}
                              <Route path="/ddp/create" element={<DDPCreateGate />} />
                              <Route path="/ddp/list" element={<ProtectedRoute requiredRoles={['CLIENT', 'MANAGER', 'PESEUR']}><DDPListPage /></ProtectedRoute>} />
                              <Route path="/ddp/:id" element={<ProtectedRoute requiredRoles={['CLIENT', 'MANAGER', 'PESEUR']}><DDPDetailPage /></ProtectedRoute>} />
                              <Route path="/operator/register" element={<OperatorRegisterPage />} />
                              <Route path="/operator/register/pending" element={<OperatorRegisterPendingPage />} />
                              <Route path="/chefzone/ddp" element={<ProtectedRoute requiredRoles={["CHEFZONE"]}><ChefZoneDDPDashboard /></ProtectedRoute>} />
              
              <Route path="/clients" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT', 'PESEUR', 'ACCOUNTANT', 'SUPER']}>
                  <ClientsPage />
                </ProtectedRoute>
              } />
              <Route path="/transporteurs" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT']}>
                  <TransporteursPage />
                </ProtectedRoute>
              } />
              <Route path="/transporteurs/drivers" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT', 'PESEUR']}>
                  <DriversPage />
                </ProtectedRoute>
              } />
              <Route path="/transporteurs/drivers/:id" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT', 'PESEUR']}>
                  <DriverDetailPage />
                </ProtectedRoute>
              } />
              <Route path="/transporteurs/trucks" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT', 'PESEUR']}>
                  <TrucksPage />
                </ProtectedRoute>
              } />
              <Route path="/transporteurs/trucks/:id" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT', 'PESEUR']}>
                  <TruckDetailPage />
                </ProtectedRoute>
              } />
              <Route path="/trucks" element={<Navigate to="/transporteurs/trucks" replace />} />
              
              <Route path="/products" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER']}>
                  <ProductsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/ports" element={
                <ProtectedRoute requiredRoles={['ADMIN']}>
                  <PortsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/moles" element={
                <ProtectedRoute requiredRoles={['ADMIN']}>
                  <MolesPage />
                </ProtectedRoute>
              } />
              
              <Route path="/weighbridges" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER']}>
                  <WeighbridgesPage />
                </ProtectedRoute>
              } />
              
              <Route path="/users" element={
                <ProtectedRoute requiredRoles={['ADMIN']}>
                  <UsersPage />
                </ProtectedRoute>
              } />
              <Route path="/drivers" element={
                <ProtectedRoute requiredRoles={['CLIENT']}>
                  <UsersPage />
                </ProtectedRoute>
              } />
              
              <Route path="/tickets" element={
                <ProtectedRoute>
                  <TicketsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/certificates" element={
                <ProtectedRoute requiredRoles={['MANAGER', 'CLIENT', 'ACCOUNTANT', 'PESEUR', 'SUPER']}>
                  <CertificatesPage />
                </ProtectedRoute>
              } />
              
              <Route path="/bills" element={
                <ProtectedRoute requiredRoles={['MANAGER', 'ACCOUNTANT', 'CLIENT', 'SUPER', 'PESEUR']}>
                  <BillsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/payments" element={
                <ProtectedRoute requiredRoles={['MANAGER', 'ACCOUNTANT', 'CLIENT', 'SUPER']}>
                  <PaymentsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/reports" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'PESEUR']}>
                  <ReportsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/tracking" element={
                <ProtectedRoute requiredRoles={['ADMIN', 'MANAGER', 'CLIENT']}>
                  <TruckTrackingPage />
                </ProtectedRoute>
              } />
              
              <Route path="/error-logs" element={
                <ProtectedRoute requiredRoles={['ADMIN']}>
                  <ErrorLogsPage />
                </ProtectedRoute>
              } />

              <Route path="/admin-stats" element={
                <ProtectedRoute requiredRoles={['ADMIN']}>
                  <AdminStatsPage />
                </ProtectedRoute>
              } />
              
              <Route path="/system-config" element={
                <ProtectedRoute requiredRoles={['ADMIN']}>
                  <SystemConfigPage />
                </ProtectedRoute>
              } />
              
              {/* Catch all route */}
              <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
            
            <ToastContainer />
          </div>
        </Router>
      </ToastProvider>
      </MailingProvider>
      </LocaleProvider>
    </AuthProvider>
  );
}

export default App;